import { Component, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-swagger-validation-error-modal',
  standalone: true,
  imports: [],
  templateUrl: './swagger-validation-error-modal.component.html',
  styleUrl: './swagger-validation-error-modal.component.scss',
})
export class SwaggerValidationErrorModalComponent {
  activeModal = inject(NgbActiveModal);

  @Input() errorMessage: string = '';
}
